export const environment = {
  production: false,
  baseUrl: 'https://brfapi.omsdev.in/api'
};
